import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Home from './components/Home';
import MultiStepInvestorForm from './page/MultiStepInvestorForm';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/know-more/*" element={<Home />} /> {/* Wildcard fixed */}
        <Route path="/form" element={<MultiStepInvestorForm />} />
      </Routes>
    </Router>
  );
};

export default App;
